export default {
  Arts: 'Arts',
  'Arts/Books': 'Arts/Literature',
  'Arts/Design': 'Arts/Design',
  'Arts/Fashion & Beauty': 'Arts/Fashion & Beauty',
  'Arts/Food': 'Arts/Food',
  'Arts/Performing Arts': 'Arts/Performing Arts',
  'Arts/Visual Arts': 'Arts/Visual Arts',
  Business: 'Business',
  'Business/Careers': 'Business/Careers',
  'Business/Entrepreneurship': 'Business',
  'Business/Investing': 'Business/Investing',
  'Business/Management': 'Business/Management & Marketing',
  'Business/Marketing': 'Business/Management & Marketing',
  'Business/Non-Profit': 'Business',
  Comedy: 'Comedy',
  'Comedy/Comedy Interviews': 'Comedy',
  'Comedy/Improv': 'Comedy',
  'Comedy/Stand-Up': 'Comedy',
  Education: 'Education',
  'Education/Courses': 'Education',
  'Education/How To': 'Education',
  'Education/Language Learning': 'Education',
  'Education/Self-Improvement': 'Education',
  Fiction: null,
  'Fiction/Comedy Fiction': null,
  'Fiction/Drama': null,
  'Fiction/Science Fiction': null,
  Government: 'Government & Organizations',
  'Health & Fitness': 'Health',
  'Health & Fitness/Alternative Health': 'Health/Alternative Health',
  'Health & Fitness/Fitness': 'Health/Fitness & Nutrition',
  'Health & Fitness/Medicine': 'Health',
  'Health & Fitness/Mental Health': 'Health',
  'Health & Fitness/Nutrition': 'Health/Fitness & Nutrition',
  'Health & Fitness/Sexuality': 'Health/Sexuality',
  History: null,
  'Kids & Family': 'Kids & Family',
  'Kids & Family/Education for Kids': 'Kids & Family',
  'Kids & Family/Parenting': 'Kids & Family',
  'Kids & Family/Pets & Animals': 'Kids & Family',
  'Kids & Family/Stories for Kids': 'Kids & Family',
  Leisure: 'Games & Hobbies',
  'Leisure/Animation & Manga': 'Games & Hobbies',
  'Leisure/Automotive': 'Games & Hobbies/Automotive',
  'Leisure/Aviation': 'Games & Hobbies/Aviation',
  'Leisure/Crafts': 'Games & Hobbies',
  'Leisure/Games': 'Games & Hobbies/Other Games',
  'Leisure/Hobbies': 'Games & Hobbies',
  'Leisure/Home & Garden': 'Games & Hobbies',
  'Leisure/Video Games': 'Games & Hobbies/Video Games',
  Music: 'Music',
  'Music/Music Commentary': 'Music',
  'Music/Music History': 'Music',
  'Music/Music Interviews': 'Music',
  News: 'News & Politics',
  'News/Business News': 'News & Politics',
  'News/Daily News': 'News & Politics',
  'News/Entertainment News': 'News & Politics',
  'News/News Commentary': 'News & Politics',
  'News/Politics': 'News & Politics',
  'News/Sports News': 'News & Politics',
  'News/Tech News': 'News & Politics',
  'Religion & Spirituality': 'Religion & Spirituality',
  'Religion & Spirituality/Buddhism': 'Religion & Spirituality/Buddhism',
  'Religion & Spirituality/Christianity': 'Religion & Spirituality/Christianity',
  'Religion & Spirituality/Hinduism': 'Religion & Spirituality/Hinduism',
  'Religion & Spirituality/Islam': 'Religion & Spirituality/Islam',
  'Religion & Spirituality/Judaism': 'Religion & Spirituality/Judaism',
  'Religion & Spirituality/Religion': 'Religion & Spirituality',
  'Religion & Spirituality/Spirituality': 'Religion & Spirituality/Spirituality',
  Science: 'Science & Medicine',
  'Science/Astronomy': 'Science & Medicine',
  'Science/Chemistry': 'Science & Medicine',
  'Science/Earth Sciences': 'Science & Medicine',
  'Science/Life Sciences': 'Science & Medicine',
  'Science/Mathematics': 'Science & Medicine',
  'Science/Natural Sciences': 'Science & Medicine',
  'Science/Nature': 'Science & Medicine',
  'Science/Physics': 'Science & Medicine',
  'Science/Social Sciences': 'Science & Medicine/Social Sciences',
  'Society & Culture': 'Society & Culture',
  'Society & Culture/Documentary': 'Society & Culture',
  'Society & Culture/Personal Journals': 'Society & Culture/Personal Journals',
  'Society & Culture/Philosophy': 'Society & Culture/Philosophy',
  'Society & Culture/Places & Travel': 'Society & Culture/Places & Travel',
  'Society & Culture/Relationships': 'Society & Culture',
  Sports: 'Sports & Recreation',
  'Sports/Baseball': 'Sports & Recreation',
  'Sports/Basketball': 'Sports & Recreation',
  'Sports/Cricket': 'Sports & Recreation',
  'Sports/Fantasy Sports': 'Sports & Recreation',
  'Sports/Football': 'Sports & Recreation',
  'Sports/Golf': 'Sports & Recreation',
  'Sports/Hockey': 'Sports & Recreation',
  'Sports/Rugby': 'Sports & Recreation',
  'Sports/Running': 'Sports & Recreation',
  'Sports/Soccer': 'Sports & Recreation',
  'Sports/Swimming': 'Sports & Recreation',
  'Sports/Tennis': 'Sports & Recreation',
  'Sports/Volleyball': 'Sports & Recreation',
  'Sports/Wilderness': 'Sports & Recreation',
  'Sports/Wrestling': 'Sports & Recreation',
  Technology: 'Technology',
  'True Crime': null,
  'TV & Film': 'TV & Film',
  'TV & Film/After Shows': 'TV & Film',
  'TV & Film/Film History': 'TV & Film',
  'TV & Film/Film Interviews': 'TV & Film',
  'TV & Film/Film Reviews': 'TV & Film',
  'TV & Film/TV Reviews': 'TV & Film',
};
